import { showClubName } from 'app/components/club-name.utils';
import { Text } from 'app/design/primitives/text';
import { ActivitySectorTag, type ActivitySectorTagProps } from 'app/components/profile/activity-sector-tag';
import { Row } from 'app/design/primitives/box';

import { useNavigation } from 'app/hooks/navigation';
import type { Statistics } from 'app/network/statistics';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { navigateInCurrentNavigatorWithFallback } from 'app/screens/root-stack-helper';
const theme = createDSTheme();

export function ClubName({
  groups,
  asTags = false,
  smaller,
  preventNavigateToClubMembers = false,
  tagBackgroundColor,
}: {
  groups: Statistics['groups'] | undefined;
  asTags?: boolean;
  smaller?: boolean;
  preventNavigateToClubMembers?: boolean;
  tagBackgroundColor?: ActivitySectorTagProps['backgroundColor'];
}) {
  const { t } = useTranslation();
  const navigation = useNavigation();

  if (!showClubName(groups) || !groups) {
    return null;
  }

  const Base = preventNavigateToClubMembers ? View : Pressable;
  const navigationProps = !preventNavigateToClubMembers && {
    onPress: () =>
      navigateInCurrentNavigatorWithFallback(navigation, 'group-members', 'profile', {
        groupIds: groups.map((g) => g.id),
      }),
  };

  if (asTags) {
    return (
      <Base {...navigationProps} style={{ alignSelf: 'stretch' }}>
        <Row
          flexWrap="wrap"
          style={{
            columnGap: theme.spacing['spacing.general.x1'],
            rowGap: theme.spacing['spacing.general.x1'],
          }}
        >
          {groups.map((group, index) => (
            <ActivitySectorTag
              backgroundColor={tagBackgroundColor}
              key={group.id}
              label={index === 0 ? t('clubName', { ns: 'neighbour-profile', clubName: group.name }) : group.name}
            />
          ))}
        </Row>
      </Base>
    );
  }

  return (
    <Base
      {...navigationProps}
      style={{
        alignSelf: 'flex-start',
        backgroundColor: theme.colors['surface.tertiary'],
        borderRadius: smaller ? 4 : 8,
        paddingHorizontal: smaller ? 3 : 10,
        paddingVertical: smaller ? 3 : 6,
      }}
    >
      <Text
        style={{
          color: theme.colors['text.brand'],
          fontWeight: '700',
          fontSize: 12,
        }}
      >
        {t('clubName', {
          ns: 'neighbour-profile',
          clubName: groups.map((a) => a.name).join(', '),
        })}
      </Text>
    </Base>
  );
}
